import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostForgotPasswordRequest = {
    email: string;
};

export const postForgotPassword = createPostEndpoint<PostForgotPasswordRequest, string>(
	({ email }) => `/api/v3/security/authentication/forgot-password/${email}`
);
